import apis from "../../core/apis.js";

class BoardingCheckinResource {
  constructor($resource) {
    "ngInject";

    this.$resource = $resource;
  }

  saveConfig(payload) {
    return this.$resource(apis.boardingCheckin).save(payload);
  }

  getConfig(level, key) {
    return this.$resource(apis.boardingCheckin + "check_in").get({
      level,
      key,
    });
  }
}

export default BoardingCheckinResource;



// WEBPACK FOOTER //
// ./src/resources/boardingCheckin/boardingCheckin.resource.js